<template>
  <el-container class="services_cases_container">
     <el-main class="w">
          <div v-for="(item,index) in cases" :key="index" :id="generateId(index)" >
             
             <div class="service">
                 <div class="_icon"><img :src="item.service_icon"/></div>
                 <div class="_title"><h2>{{item.service_title}}</h2></div>
                 <div class="_intro">{{item.service_intro}}</div>

             </div>

             <el-row class="case">
               <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                   <img ref="pic" class="case_img" :src = "item.img" />
               </el-col>

               <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" justify="center">
                   <div class="info">
                       <div class="_title"><h3>{{item.title}}</h3></div>
                       <div class="_intro"><p>{{item.intro}}</p></div>
                   </div>
               </el-col>
             </el-row>

           </div>
               </el-main>
               </el-container>
               </template>

               <script>
               const cases = [

{    
    service_icon:require('../assets/direction_icon.png'),
    service_title:'找方向 - 数字互联战略规划',
    service_intro:
    '通过企业高层展开深入对话+下沉到一线事务的全方位服务模式，以数字互联创新的专业视角与方法论，重新发掘出新时代背景下与企业独特基因匹配度最高的新方向、新机遇，对现有战略进行及时校正以避免重大损失。',
    title : '中国铝业——重塑在产业数字互联中的独特优势',
    intro :'我们帮助中国铝业从搭建产品销售网络的战略方向校正到更符合自身独特优势的以搭建供应链信用网络何核心价值的战略方向，并明确了“赋能网络信用”这个不可获取的数字化价值。在此基础上，中国铝业不仅避免了巨大财务浪费，还在内部首次尝试开展内部创业孵化机制，并与阿里集团在产业数字化方面顺利展开全方位合作，避免让战略成为业务的负担，而真正起到了超级杠杆的效果。', 
    img:require('../assets/zhonglv2.png')
},


{
    service_icon:require('../assets/learning_icon.png'),
    service_title:'提认知 - 企业数字创新学院',
    service_intro:'用高度专业的工作坊式授课方式，将专业观点与创新方法论带到企业中来，并结合企业当前实际重要目标让学员快速完成“看到”、“感到”、“做到”三个层次的提升。',
    title : '民生银行——激发内部数字创新活力',
    intro :'我们协助民生银行从当今互联金融技术与市场趋势出发，推出国内首家银行系在线投顾平台——95568财富圈。我们为民生团队引入成熟的互联产品管理与项目运作方法，梳理、构架团队职责体系.同时我们为管理团队度身定制相关培训课程，帮助团队内建出高效、创新的互联产品管理能力',
    img: require('../assets/minsheng2.png')
},

{
    service_icon:require('../assets/prize_icon.png'),
    service_title:'推落地 - 数字创新项目孵化与团队搭建',
    service_intro:'围绕企业在互联市场的整体定位，根据实际业务需求协助企业进行数字创新团队架构与职责规划，并提供来自互联领域专业人才的引进服务',
    title : '中国青年报——老牌报业的新媒体重生',
    intro : '我们深度挖掘中国青年报自身优势并与数字创新趋势结合，成功从单一的内容生产与发布渠道升级为高校服务渠道。与此同时，在WeTouch的协助下，中青首次建立一支拥有成熟工作与管理体系的互联团队，为各项互联业务开拓提供坚实的组织保证。',
    img: require('../assets/qm2.png')
},

               ]



export default {
    name: 'CasesInfo',
    props: {
        _title: String,
        _intro: String
      },
      
    data() {
          return{
            cases:cases,
         }
      },

   methods:{
       generateId(index){
           return "service_"+index}
       }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
margin: 40px 0 0;
}
ul {
    list-style-type: none;
padding: 0;
}
li {
display: inline-block;
margin: 0 10px;
}
a {
color: #42b983;
}

.cases_container{
    background-color:#337ab7;
color:white;
padding:20px;}

.service {
    padding:70px 30px 50px 30px;
    }

.service ._intro{
    line-height:1.5;
    }

.service ._icon img{
    width:50px}

.case{
    padding:20px 30px}

.case img{
    width:100%}

.case .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    text-align: left;
    padding: 0 10px;}

#service_0 {
    background-color:#639BF1}

#service_1 {
    background-color:#3B5998}

#service_2 {
    background-color:#293E6A}

</style>
